

import { useState } from 'react';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: 'O curso é apenas presencial?',
      answer: 'Sim, nosso curso é 100% presencial para garantir máxima interação, networking e aproveitamento do conteúdo. Acreditamos que a experiência presencial é fundamental para o aprendizado efetivo em tributação.'
    },
    {
      question: 'Qual o perfil ideal do participante?',
      answer: 'O curso é direcionado para contadores, analistas fiscais, gestores tributários, empresários, estudantes de contabilidade/direito e consultores que desejam se atualizar sobre a reforma tributária 2024/2025.'
    },
    {
      question: 'Há certificado de participação?',
      answer: 'Sim! Todos os participantes recebem certificado de participação com 8 horas de carga horária, válido para pontuação em órgãos de classe como CRC e outras entidades profissionais.'
    },
    {
      question: 'Quais são as formas de pagamento?',
      answer: 'Aceitamos cartão de crédito (até 3x sem juros), PIX (5% de desconto), boleto bancário e transferência bancária. Para empresas, oferecemos condições especiais de pagamento.'
    },
    {
      question: 'E se eu não puder comparecer após a inscrição?',
      answer: 'Oferecemos transferência gratuita para a próxima turma até 48h antes do evento. Cancelamentos com mais de 7 dias de antecedência têm reembolso de 100% do valor pago.'
    },
    {
      question: 'O material didático está incluso?',
      answer: 'Sim! Está incluso apostila completa, planilhas de cálculo, templates, coffee break e acesso a recursos digitais complementares por 30 dias após o curso.'
    },
    {
      question: 'Há desconto para grupos?',
      answer: 'Sim! Para inscrições de 3 ou mais pessoas da mesma empresa, oferecemos 15% de desconto. Para grupos de 5 ou mais, o desconto é de 25%. Entre em contato para condições especiais.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Dúvidas Frequentes
            </h2>
            <p className="text-xl text-gray-600">
              Esclarecemos as principais questões sobre nosso projeto de Expansão 
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <h3 className="font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-blue-800 text-xl`}></i>
                  </div>
                </button>
                
                {openFAQ === index && (
                  <div className="px-6 pb-4">
                    <div className="border-t border-gray-100 pt-4">
                      <p className="text-gray-700 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <div className="flex items-center justify-center mb-4">
                <div className="w-12 h-12 bg-blue-800 rounded-lg flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-white text-xl"></i>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Ainda tem dúvidas?
              </h3>
              <p className="text-gray-600 mb-4">
                Nossa equipe está pronta para ajudar você
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://wa.me/5599981024030"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp
                </a>
                <a
                  href="mailto:impetuscontatos@gmail.com"
                  className="bg-blue-800 hover:bg-blue-900 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
                >
                  <i className="ri-mail-line mr-2"></i>
                  E-mail
                </a>
                <a
                  href="tel:+551133334444"
                  className="border-2 border-blue-800 text-blue-800 hover:bg-blue-800 hover:text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2"></i>
                  (99) 98102-4030
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;


